import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import ListResource from './ListResource.jsx';

const api = '/api/site/shares';

const ListShares = () => {
  const [res, req] = useHttpStatus();
  const { t } = useTranslation();
  const [edit, setEdit] = useState(null);

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { order: -1, title: 1, createdAt: -1 },
        cols: [
          { key: 'order', sortable: true, renderer: ({data,row,key,refresh,setRefresh}) => {
            return edit && edit._id === row._id ? (
              <input
                className="order-input"
                value={edit.value ? edit.value : ''}
                size={1}
                onClick={(evt)=>evt.stopPropagation()}
                onChange={(evt) => {
                  setEdit({...edit, value: evt.target.value})
                }}
                onKeyPress={async (evt) => {
                  if ( evt.key === 'Enter' ) {
                    await req({
                      url: `${api}/updateOrder`,
                      method: 'post',
                      data: edit
                    })
                    setEdit(null);
                    setRefresh(refresh+1);
                  }
                }}
                onKeyDown={(evt) => {
                  if ( evt.key === 'Escape' ) {
                    setEdit(null);
                  }
                }}
              />
            ) : (
            <span 
              className="border pl-3 pr-3"
              onClick={(evt) => {
                setEdit({_id: row._id, value: data})
                evt.stopPropagation();
                evt.preventDefault();
                setTimeout(()=>{
                  let input = document.querySelector('.order-input');
                  if ( input ) {
                    input.select();
                    input.focus();
                  }
                }, 100);
              }}
            >{data}</span>
            )
          }},
          { key: 'title', sortable: true },
          {
            key: 'updatedAt',
            sortable: true,
            getter: (v) => moment(v).format('YYYY/M/D h:mm a'),
          },
        ],
      }}
    >
      {/* {({ refresh }) => (
        <FormHttpBtn
          res={res}
          className="btn btn-secondary float-right"
          icon={faBan}
          onClick={async () => {
            await req({
              url: `${api}/popup/disable`,
              method: 'patch',
            });

            refresh();
          }}
        >
          {t('Turn Off Popups')}
        </FormHttpBtn>
      )} */}
    </ListResource>
  );
};

export default ListShares;
